<script setup lang="ts">
  import { CartLayout, CartWithSummaryLayout } from '@storefront/components';
  import { useVerifiedCart } from '@storefront/storefront';

  defineOptions({
    layout: [CartLayout, CartWithSummaryLayout],
    inheritAttrs: false,
  });

  interface Props {
    isCeneoEnabled: boolean;
  }

  defineProps<Props>();

  const cart = useVerifiedCart();
</script>
<template>
  <FormController :action="$route('web.cart.conditions.update')" method="PATCH" :data="cart" v-slot="{ data, processing, submit }">
    <div class="conditions-form">
      <OrderConditions :cart :isCeneoEnabled />
      <UiButtonGroup>
        <SfButton primary small :loading="processing" @click="submit">
          {{ $t('SHOP.CART.ACTION.GO_TO_SUMMARY') }}
        </SfButton>
      </UiButtonGroup>
    </div>
  </FormController>

  <RouterView />
</template>
<style lang="scss">
  .conditions-form {
    display: flex;
    flex-direction: column;
    gap: var(--form-gap-y) var(--form-gap-x);
  }
</style>
